'use client';

import type { ReactNode } from 'react';
import { stepAfterAccount } from '../health-plan/plan-details';
import { useLegacySignupParams } from '../hooks/useLegacySignupParams';
import { useSignupNavigation } from '../hooks/useSignupNavigation';
import { useSignupSponsor } from '../hooks/useSignupSponsor';
import { useSignupFlowStore } from '../stores/signup-flow-store';
import { ReturnToStep } from './ReturnToStep';

/**
 * For the account and code steps: a member the welcome-back page resumed is
 * already signed in, so both steps step aside for the step after the code,
 * and no code is sent. Every other flow sees the step as before. A health-plan
 * sponsor's plan details come next, so a sponsor still loading is waited for.
 */
export function ResumedSignInSkip({ children }: { children: ReactNode }) {
  const linkParams = useLegacySignupParams();
  const { path } = useSignupNavigation();
  const resumed = useSignupFlowStore(
    (state) => state.resumedSignIn && state.signInContact !== null,
  );
  const sponsor = useSignupSponsor(
    linkParams.clientId,
    linkParams.subClientId,
    resumed && path !== 'no-employer',
  );
  if (!resumed) return children;
  if (path !== 'no-employer' && sponsor.isPending) return null;
  return (
    <ReturnToStep
      step={stepAfterAccount({ features: sponsor.data?.features, flow: linkParams.flow, path })}
    />
  );
}
